import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../styles/index";
import { NumberPickerField } from "./field/NumberPickerField";
var useStyles = makeStyles(function () { return ({
    field: {
        flex: '1 0 0',
        minWidth: 0,
    },
}); }, { name: 'SnNumberPicker' });
/**
 * 数値選択コンポーネント。
 */
export var NumberPicker = function (props) {
    var className = props.className, style = props.style, value = props.value, placeholder = props.placeholder, _a = props.min, min = _a === void 0 ? 0 : _a, _b = props.max, max = _b === void 0 ? 100 : _b, clearable = props.clearable, onChange = props.onChange;
    var _c = useState(null), localValue = _c[0], setLocalValue = _c[1];
    var currentValue = value !== undefined ? value : localValue;
    var handleChangeNumber = useCallback(function (selectedValue) {
        setLocalValue(selectedValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(selectedValue);
    }, [onChange]);
    var classes = useStyles(props);
    return (React.createElement(NumberPickerField, { className: classNames(className, classes.field), classes: props.classes, style: style, value: currentValue, onChange: handleChangeNumber, clearable: clearable, placeholder: placeholder, min: min, max: max }));
};
